import React from 'react'

import withStyles from '@material-ui/core/styles/withStyles'
import Typography from '@material-ui/core/Typography'
import { EventListCard } from '../../Event'
import { Word } from '../../../containers'
import PersonIcon from '@material-ui/icons/Person'
import DoneIcon from '@material-ui/icons/Done'
import StarIcon from '@material-ui/icons/Star'
import { WID } from '../../../constants/Language';

const styles = theme => ({
  eventTabBox: {
    paddingBottom: theme.spacing.unit * 4,
    width: `calc(100% - ${theme.spacing.unit * 2}px)`,
    margin: `0 auto`,
  },
  title: {
    display: 'flex',
    alignItems: 'center',
    borderBottom: `1px solid ${theme.palette.grey[300]}`,
    margin: `${theme.spacing.unit * 2}px 0`,
    padding: theme.spacing.unit,
  },
  icon: {
    marginRight: theme.spacing.unit * 2,
  }
})

class EventTab extends React.Component {
  render() {
    const { classes, userProfile } = this.props
    return (
      <div className={classes.eventTabBox}>
        <div>
          <Typography variant='title' className={classes.title}><PersonIcon className={classes.icon}/>
            <Word wid={WID.EVENT_TAB.OWNER}/>
          </Typography>
          <EventListCard grid disabledMonthlyCard search={{ author: userProfile.userName }}/>
        </div>
        <div>
          <Typography variant='title' className={classes.title}><DoneIcon className={classes.icon}/>
            <Word wid={WID.EVENT_TAB.ATTEND}/>
          </Typography>
          <EventListCard grid disabledMonthlyCard search={{ attend: userProfile.userName }}/>
        </div>
        <div>
          <Typography variant='title' className={classes.title}><StarIcon className={classes.icon}/>
            <Word wid={WID.EVENT_TAB.INTEREST}/>
          </Typography>
          <EventListCard grid disabledMonthlyCard search={{ interest: userProfile.userName }}/>
        </div>
      </div>
    )
  }
}


export default withStyles(styles, { withTheme: true })(EventTab)


// WEBPACK FOOTER //
// ./src/Pages/User/components/EventTab.js